<section class="healthcare-banner instool aashi">
    <div class="container">
        <div class="row zmc">
            <div class="col-lg-9 col-md-9 col-sm-12 col-12 service-heading">
                <div class="headtext">
                    <h1>Always remember your loved ones via iLastword platform

                    </h1><br>
<title>iLastWord Case Study - Creative Web Development Solutions | Vidhema</title>


                    <!-- <p >We design and build superior digital products, delegating seamless user experiences across all modern platforms and devices and helping brands to expand their business globally. -->
                    <!-- </p><a  routerLink="/getaquote.html"
                                            class="ar_contect-industries-header"><span
                                                    >Request a Free
                                                    Quote</span></a> -->
                </div>
            </div>
        </div>
    </div>

</section>

<div class="casestudy-details pt-120 pb-120">
    <div class="container logo-box">
        <img class="ilast-logo" src="assets/images/ilastword.webp" alt="iLastword">
    </div>
    <div class="container">
        <div class="row gy-5">
            <div class="col-lg-8">
                <div class="case-details-single">
                    <h2>iLastword</h2>
                    <p>
                        iLastword became the first online portal where people can write about their loved ones after they
                        passed away or can give tribute to their loved ones who are in critical condition. Where the person
                        who is ill can post something about their journey into this world and can publish it on its own or
                        can make nominee to publish it and handle the account.
    
                    </p>
                    <img src="assets/images/jpeg-optimizer_ilast.jpg" alt="image" class="img-fluid">
                </div>
            </div>
            <div class="col-lg-4">
                <div class="case-sidebar-area">
                    <ul class="case-info-list">
                        <li><span><img src="../../../assets/images/sidebar-arrow.svg" alt="image">Team Size :</span>
                            <h5>8 Members</h5>
                            <h5>
                                Project Manager | Business Analyst | Tech Lead | Developers | Designers | Quality
                                Analyst</h5>
                        </li>
                        <li><span><img src="../../../assets/images/sidebar-arrow.svg" alt="image">Industry :</span>
                            <h5>Social Media Platform</h5>
                        </li>
                        <li><span><img src="../../../assets/images/sidebar-arrow.svg" alt="image">Duration :</span>
                            <h5> 2 Years
                            </h5>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-lg-12 case-details-single">
            

                <div class="area">
                    <h4> Who is the client?</h4>
                <p class="para">The client was a marketing expert who wanted a platform where people can post some
                    memories of their loved ones. Also, including various features for the patients who can take a
                    leverage of this platform.The client was himself a patient and at the time of treatment, he had
                    thought of developing an application where people can write about their loved ones as a part of
                    their memory or a tribute to them. </p>
                </div>
                <div class="area">
                    <h4> Purpose
                    </h4>
                    <p class="para">The client’s main purpose was to have an application where people can post heartfelt
                        messages or memories with their loved ones. Where they can truly express their gratitude towards
                        them and what influence they had on them. Also, the users can comment and like others' posts while
                        posting something from their point of view. </p>
                </div>
            </div>
        </div>
    </div>
    <div class="full-area-bg">
        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-md-8">
                    <div class="case-details-single">
                        <div class="area">
                            <h4> Challenge 
                            </h4>
                            <p class="para text-design">
                           
                                    The main challenge the client faced is that he only had the idea to have an application like this, or moreover he doesn’t know anything much of that sort. iLastword wanted to have a platform where family members or friends of the deceased or ill person can post some memories they have shared and let others post something via the platform. 
                              
                            
                            </p>
                            <p class="para">
                                Also, the ill person can share their point of story on this platform where that person
                                can publish it on their own or can make someone close a nominee and that person can
                                publish it after some time.
                            </p>
                            <div class="list-title  list-space"><img class="img-value"
                                    src="../../../assets/images/list-arrow.svg" alt="image">
                                <p class="para">
                                    The main concern of the client was that the deployed product does not have to look
                                    like any other social media platform. Therefore, a very close look at the UI phase
                                    and the development phase was kept to achieve this difference in experience.

                                </p>
                            </div>
                            <div class="list-title  list-space"><img class="img-value"
                                    src="../../../assets/images/list-arrow.svg" alt="image">
                                <p class="para">


                                    More than writing memorials and tributes, the app had features such as SOS alerts,
                                    notifying people in case of emergency, asset management, critical alerts, posting,
                                    and commenting which were a custom build.

                                </p>
                            </div>
                            <div class="list-title  list-space"><img class="img-value"
                                    src="../../../assets/images/list-arrow.svg" alt="image">
                                <p class="para">


                                    The user experience and user interface needed to take care of from both ends making
                                    it user-friendly for the users as it was mostly used by old age people.

                                </p>
                            </div>

                        </div>

                    </div>
                </div>
                <div class="col-xs-12 col-md-4">
                    <img src="../../../assets/images/girl.svg.svg" alt="Girl Building">
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="case-details-single">
                    <div class="area">
                        <h4> Solution</h4>
                        <p class="para">When the client came to us he only had the thought of creating a website of this
                            nature. The client was not very sure what he wanted in the application. Then we did rigorous
                            research related to this website and shared our ideas to include the particular features.
                            Vidhema Technologies developed the mobile app and website with this idea making users want
                            to spend more time on the app. We offered him different features that could be implemented
                            in the app.</p>
                        <div class="solution-box">
                            <div class="col-12 para-text">
                                <h4 class="phase-text-value"> Phase 1:</h4>

                                <p>
                                    iLastword is a mobile application development project and a unique platform where
                                    users needed to post something related to a memory they had with some deceased
                                    person. Consequently, we need to understand the expectations and aspirations of both
                                    the hosts i.e; the person writing about himself in his/her critical times or the
                                    other person writing in the memory of their loved ones. Here, we have to bring
                                    iLastword to a successful fruition.

                                </p>
                                <p>
                                    The first phase of the development included:
                                </p>
                                <div class="list-title  list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para">


                                        Requirement Elicitation or Gathering: This involves a thorough understanding of
                                        what was expected from this platform. What features can be included? What those
                                        features must be capable of doing? What should the final result be?
                                    </p>
                                </div>
                                <div class="list-title  list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para">


                                        Preparing the ER Diagram: Establishing relationships among the different
                                        functions of the mobile app, the database, and its tables.
                                    </p>
                                </div>
                                <div class="list-title  list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para">


                                        Prototyping and Wireframing: These can be used to show how the different screens
                                        and elements will interact and flow from one section to another. It's like
                                        looking at the actual app on paper or a graphic screen.
                                    </p>
                                </div>


                            </div>
                            <div class="col-12 para-text">
                                <h4 class="phase-text-value"> Phase 2:</h4>
                                <p>
                                    With the information, we gathered in Phase 1, we started developing the mobile
                                    application. Now, Phase 2 involves
                                </p>
                                <div class="list-title  list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para">


                                        UI/UX Design: Using the wireframe, both our graphic designers as well as mobile
                                        app designers designed the look and feel for the app that would appeal to the
                                        users.
                                    </p>
                                </div>
                                <div class="list-title  list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para">


                                        Programming and Development: To leverage the benefits of modern technologies,
                                        the coding was optimized using the most recent mobile app development tools.
                                    </p>
                                </div>
                                <div class="list-title  list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para">


                                        UAT: User acceptance testing was performed at several, but critical, stages so
                                        that any potential disparities could be caught in time and taken care of.
                                    </p>
                                </div>
                                <div class="list-title  list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para">


                                        Integration of Database: It was crucial to ensure stability because all valuable
                                        information would be drawn from the database. We make sure via database
                                        integration with the interface of the mobile application.
                                    </p>
                                </div>
                                <div class="list-title  list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para">


                                        Testing on the Vidhema side: We continuously did the testing of the mobile
                                        application from our side as per our policies and indigenous standards.
                                    </p>
                                </div>
                                <div class="list-title  list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para">


                                        Deploying the Final Product: Finally, the mobile app was deployed on both
                                        Apple’s App Store and Google Play Store.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-lg-12 case-details-single">
                <div class="area">
                    <h4> Results</h4>
                    <p class="para">iLastword is a unique application created by our team of adroit developers. We had a
                        great time developing this application. There are around 5K+ downloads of the application and
                        users are browsing this app with the utmost curiosity. Users are using this app from every
                        corner of the world to write about their memories with their loved ones.

                    </p>
                    <div class="list-title  list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">


                            The app is structured around the concept of memorizing the people who are not a part of
                            people’s lives anymore.
                        </p>
                    </div>
                    <div class="list-title  list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">


                            When a user registered for an account, the person can be an invitee or organizer.
                        </p>
                    </div>
                    <div class="list-title  list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">


                            A user can register using various platforms such as Facebook, Twitter, and Google accounts.
                        </p>
                    </div>
                    <div class="list-title  list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">


                            The profile of the user can be added with personal and professional information.
                        </p>
                    </div>
                    <div class="list-title  list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">


                            The organizer can view the profile details of the invitee, chat online with them, comment,
                            and react to the posts.
                        </p>
                    </div>
                    <div class="list-title  list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">


                            The invitee can also send the follow or friend requests to other users.
                        </p>
                    </div>
                    <div class="list-title  list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">


                            The users can post something about the deceased person to make their memory live for a
                            lifetime.
                        </p>
                    </div>
                    <div class="list-title  list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">


                            The organizer can view the profile details of the invitee, chat online with them, comment,
                            and react to the posts.
                        </p>
                    </div>
                    <div class="list-title  list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">


                            The usability and thorough experience of the mobile app was well received and it is rapidly
                            gaining acceptance among its core user base.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section class="quote-box" style="    background-color: #0d052a;">
        <div class="container">
            <div class="row">
                <div class="col-md-9">
                    <h4>Are You Ready To Discuss Your Project With Us?</h4>
                </div>
                <div class="col-md-3">
                    <button routerLink="/hire-ionic-developers.html">Hire Our Experts</button>
                </div>
            </div>
        </div>
    </section>
    <div class="container">
        <div class="row gy-5">
            <div class="col-lg-12">
                <div class="case-details-single">

                    
                    <!-- <p>Also, the ill person can share their point of story on this platform where that person can publish it on their own or can make someone close a nominee and that person can publish it after sometime. </p>
                    <div class="list-title"><img src="../../../assets/images/list-arrow.svg" alt="image">
                        <p>
                         The main concern of the client was that the deployed product does not look like any other social media platform. Therefore, a very close look at the UI phase and the development phase was kept to achieve this difference in experience.
                        </p>
                             </div>
                             <div class="list-title"><img src="../../../assets/images/list-arrow.svg" alt="image">
                                <p>
                                    More than writing memorials and tributes, the app had features such as SOS alerts, notifying people in case of emergency, asset management, critical alerts, posting, and commenting which were a custom build.
                                </p>
                                     </div>
                           
                                     <div class="list-title"><img src="../../../assets/images/list-arrow.svg" alt="image">
                                        <p>
                                            The user experience and user interface needed to take care of from both ends making it user-friendly for the users as it was mostly used by old age people. 
                                        </p>
                                             </div> -->
                    <!-- <div class="container"> -->



                    <!-- </div> -->
                    <div class="area">
                        <h4>Technologies and Tools </h4>
                        <ul class="process-list half-description tech-des">
                            <li>
                                <div class="list-title  list-space"><img
                                        src="../../../assets/images/angular-logo.svg" alt="image"
                                        class="tech-logo">
                                    <!-- <h5>Angular</h5> -->
                                </div>
                            </li>
                            <li>
                                <div class="list-title  list-space"><img
                                        src="../../../assets/images/ionic-icon.svg" alt="image"
                                        class="tech-logo">
                                    <!-- <h5>Ionic</h5> -->
                                </div>
                            </li>
                            <li>
                                <div class="list-title  list-space"><img
                                        src="../../../assets/images/nodejs.svg" alt="image"
                                        class="tech-logo">
                                    <!-- <h5>Node JS</h5> -->
                                </div>
                            </li>
                            <li>
                                <div class="list-title  list-space"><img
                                        src="../../../assets/images/MySQL_textlogo.svg" alt="image"
                                        class="tech-logo">
                                    <!-- <h5>MySQL</h5> -->
                                </div>
                            </li>
                            <li>
                                <div class="list-title  list-space"><img
                                        src="../../../assets/images/MongoDB_Logo.svg" alt="image"
                                        class="tech-logo">
                                    <!-- <h5>MongoDB  </h5> -->
                                </div>
                            </li>
                        </ul>
                    </div>



<div class="container">
<div class="row">



<div class="area">
</div>
    <h4>App Features / Web Admin Features</h4>
    <ul class="process-list half-description">
        <li>
            <div class="list-title"><img src="../../../assets/images/list-arrow.svg" alt="image">
                <h5>Memorial </h5>
            </div>
            <p class="para"> With the help of this feature you can post memorials for your loved ones.
            </p>
        </li>
        <li>
            <div class="list-title"><img src="../../../assets/images/list-arrow.svg" alt="image">
                <h5>Tributes </h5>
            </div>
            <p class="para">You can give tribute to the people who are in their critical state or living
                at the last stage of their life.
            </p>
        </li>
        <li>
            <div class="list-title"><img src="../../../assets/images/list-arrow.svg" alt="image">
                <h5>SOS Alerts</h5>
            </div>
            <p class="para">An SOS feature must be the main highlight of the app. In case of an
                emergency, an SMS should be sent out to loved ones.
            </p>
        </li>
        <li>
            <div class="list-title"><img src="../../../assets/images/list-arrow.svg" alt="image">
                <h5>Alert </h5>
            </div>
            <p class="para">An alert feature should be in place so that family and friends can be
                notified about any emergency and critical situation.
            </p>
        </li>
        <li>
            <div class="list-title"><img src="../../../assets/images/list-arrow.svg" alt="image">
                <h5>Assets Management </h5>
            </div>
            <p class="para">Sick people can give the percentage from their property and mention the
                person’s name through this feature. This will be not legal but if a person wants to do
                this via this feature they can.
            </p>
        </li>
        <li>
            <div class="list-title"><img src="../../../assets/images/list-arrow.svg" alt="image">
                <h5>Critical Alerts </h5>
            </div>
            <p class="para">This feature will notify your family and friends of your current condition
                and whereabouts so that they can reach out to you directly.
            </p>
        </li>
    </ul>
</div>
</div>







                
                  
                </div>
            </div>
        </div>
    </div>
</div>